module.exports = __webpack_public_path__ + "img/class3.6df11273.png";